import React, { useState, useEffect } from "react";
import { Card, Row, Col, message, Spin, Select } from "antd";
import { useKeycloak } from '@react-keycloak/web';
import Headings from "../../atoms/Headigs";
import {
  getResellerNetworkStats,
  getSourceCountry,
  getDestinationCountry,
  getSourceCountryUsageReport,
  getConnectedUsersReport,
  getBandwidthConsumeReport,
  getConnectedUsersMonthwiseReport,
  getConcurrentUsersReport
} from "./ducks/services";
import { LoadingOutlined } from "@ant-design/icons";
import moment from 'moment';
import { getAccountTypeWise } from "./ducks/actions";
import { getConnectedProtocols } from "./ducks/actions";
import { Pie } from '@ant-design/plots';
// import { ReactKeycloakProvider } from '@react-keycloak/web';
// import keycloak from './keycloak'; // your keycloak config
import ConnectedUserStatsChart from './components/charts/ConnectedUserStatsChart';
import NetworkStatsChart from './components/charts/NetworkStatsChart';
import UserConnectedChart from "./components/charts/UserConnectedChart";
import ConnectedProtocolsChart from "./components/charts/ConnectedProtocolsChart";
import BandwidthConsumeChart from "./components/charts/BandwidthConsumeChart";
import AccountTypeChart from "./components/charts/AccountTypeChart";
import SourceCountryUsageChart from "./components/charts/SourceCountryUsageChart";
import DAUMonthwiseChart from "./components/charts/DAUMonthwiseChart";
import ConcurrentUsersChart from "./components/charts/ConcurrentUsersChart";

const antIcon = <LoadingOutlined spin />;

const Reports = () => {
  const [fetchedTabs, setFetchedTabs] = useState({
    'source-country-usage': null,
  });
  const [activeTab, setActiveTab] = useState("source-country-usage");
  const [load, setLoad] = useState(false);
  const [networkStats, setNetworkStats] = useState();
  const [sourceDestinationCountry, setSourceDestinationCountry] = useState([]);
  const [sourceCountryUsageData, setSourceCountryUsageData] = useState([]);
  const [selectedSourceCountryMonth, setSelectedSourceCountryMonth] = useState(moment().format('YYYY-MM'));
  const [showAllSourceCountries, setShowAllSourceCountries] = useState(false); // Initialize to false for 'Top 5 Countries'
  const [userConnectedData, setUserConnectedData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(moment().format('YYYY-MM'));
  const [bandwidthConsumeData, setBandwidthConsumeData] = useState([]);
  const [selectedBandwidthMonth, setSelectedBandwidthMonth] = useState(moment().format('YYYY-MM'));
  const { keycloak } = useKeycloak();
  const [accountTypeData, setAccountTypeData] = useState([]);
  const [selectedAccountTypeMonth, setSelectedAccountTypeMonth] = useState(moment().format('YYYY-MM'));
  const [connectedProtocolsData, setConnectedProtocolsData] = useState([]);
  const [selectMonthConnectedProtocols, setSelectedMonthConnectedProtocols] = useState(moment().format('YYYY-MM'));
  const [dauMonthFrom, setDauMonthFrom] = useState('');
  const [dauMonthTo, setDauMonthTo] = useState(moment().format('YYYY-MM'));
  const [dauMonthwiseData, setDauMonthwiseData] = useState([]);
  const [concurrentFrom, setConcurrentFrom] = useState(moment().subtract(5, 'months').format('YYYY-MM'));
  const [concurrentTo, setConcurrentTo] = useState(moment().format('YYYY-MM'));
  const [concurrentData, setConcurrentData] = useState([]);

  const [loadingState, setLoadingState] = useState({
    'source-country-usage': false,
    'user-connected': false,
    'account-type-wise': false,
    'connected-protocols': false,
    'bandwidth-consumption': false,
    'connected-user-stats': false,
    'network-stats': false,
    'dau-monthwise': false,
    'concurrent-users': false,
  });

  // Month dropdown options (last 12 months)
  const monthOptions = Array.from({ length: 12 }).map((_, i) => {
    const m = moment().subtract(i, 'months');
    return {
      value: m.format('YYYY-MM'),
      label: m.format('MMMM YYYY')
    };
  });


  // Define last3MonthsOptions at the top of the Reports component:
  const last3MonthsOptions = Array.from({length: 3}).map((_, i) => {
    const m = moment().subtract(i, 'months');
    return {
      value: m.format('YYYY-MM'),
      label: m.format('MMMM YYYY')
    };
  });

  // Helper to get first and last date of a month
  const getMonthRange = (monthStr) => {
    const m = moment(monthStr, 'YYYY-MM');
    return [m.startOf('month').format('YYYY-MM-DD'), m.endOf('month').format('YYYY-MM-DD')];
  };

  // Fetch user connected data
  const fetchUserConnectedData = async (monthStr) => {
    setLoadingState(prev => ({ ...prev, 'user-connected': true }));
    const [sFromDate, sToDate] = getMonthRange(monthStr);

    if (keycloak.token && keycloak.tokenParsed?.reseller_id) {
      try {
        const response = await getConnectedUsersReport(sFromDate, sToDate, keycloak.token);

        if (response?.data?.header?.code === 200 && response?.data?.body?.dateWiseData) {
          const sortedData = response.data.body.dateWiseData.sort((a, b) =>
            moment(a.date).valueOf() - moment(b.date).valueOf()
          );
          setUserConnectedData(sortedData);
        } else {
          setUserConnectedData([]);
        }
      } catch (error) {
        console.error('Error fetching user connected data:', error);
        message.error('Failed to fetch user connected data');
        setUserConnectedData([]);
      } finally {
        setLoadingState(prev => ({ ...prev, 'user-connected': false }));
      }
    } else {
      setLoadingState(prev => ({ ...prev, 'user-connected': false }));
    }
  };

  // Fetch account type data
  const fetchAccountTypeData = async (monthStr) => {
    setLoadingState(prev => ({ ...prev, 'account-type-wise': true }));
    const [sFromDate, sToDate] = getMonthRange(monthStr);
    if (keycloak.token && keycloak.tokenParsed?.reseller_id) {
      try {
        const response = await getAccountTypeWise(sFromDate, sToDate);

        if (response?.data?.header?.code === 200 && response?.data?.body?.dateWiseData) {
          // Sort data by date
          const sortedData = response.data.body.dateWiseData.sort((a, b) =>
            moment(a.date).valueOf() - moment(b.date).valueOf()
          );
          setAccountTypeData(sortedData);
        } else {
          setAccountTypeData([]);
        }
      } catch (error) {
        setAccountTypeData([]);
        message.error(error?.response?.data?.header?.message || "Something went wrong");
      } finally {
        setLoadingState(prev => ({ ...prev, 'account-type-wise': false }));
      }
    } else {
      setLoadingState(prev => ({ ...prev, 'account-type-wise': false }));
    }
  };

  // Fetch connected protocols data
  const fetchConnectedProtocolsData = async (monthStr) => {
    setLoadingState(prev => ({ ...prev, 'connected-protocols': true }));
    const [sFromDate, sToDate] = getMonthRange(monthStr);

    if (keycloak.token && keycloak.tokenParsed?.reseller_id) {
      try {
        const response = await getConnectedProtocols(sFromDate, sToDate);
        if (response?.data?.header?.code === 200 && response?.data?.body?.data) {
          setConnectedProtocolsData(response.data.body.data);
        } else {
          setConnectedProtocolsData([]);
        }
      } catch (error) {
        setConnectedProtocolsData([]);
        message.error(error?.response?.data?.header?.message || "Something went wrong");
      } finally {
        setLoadingState(prev => ({ ...prev, 'connected-protocols': false }));
      }
    } else {
      setLoadingState(prev => ({ ...prev, 'connected-protocols': false }));
    }
  };

  // Fetch source country usage data
  const fetchSourceCountryUsageData = async (monthStr) => {
    setLoadingState(prev => ({ ...prev, 'source-country-usage': true }));
    const [sFromDate, sToDate] = getMonthRange(monthStr);
    if (keycloak.token && keycloak.tokenParsed?.reseller_id) {
      try {
        const response = await getSourceCountryUsageReport(sFromDate, sToDate, keycloak.token);
        if (response?.data?.header?.code === 200 && response?.data?.body?.data) {
          setSourceCountryUsageData(response.data.body.data);
        } else {
          setSourceCountryUsageData([]);
        }
      } catch (error) {
        setSourceCountryUsageData([]);
        message.error('Failed to fetch source country usage data');
      } finally {
        setLoadingState(prev => ({ ...prev, 'source-country-usage': false }));
      }
    } else {
      setLoadingState(prev => ({ ...prev, 'source-country-usage': false }));
    }
  };

  // Fetch bandwidth consume data
  const fetchBandwidthConsumeData = async (monthStr) => {
    setLoadingState(prev => ({ ...prev, 'bandwidth-consumption': true }));
    const [sFromDate, sToDate] = getMonthRange(monthStr);
    if (keycloak.token && keycloak.tokenParsed?.reseller_id) {
      try {
        const response = await getBandwidthConsumeReport(sFromDate, sToDate, keycloak.token);
        if (response?.data?.header?.code === 200 && response?.data?.body?.data) {
          setBandwidthConsumeData(response.data.body.data);
        } else {
          setBandwidthConsumeData([]);
        }
      } catch (error) {
        setBandwidthConsumeData([]);
        message.error('Failed to fetch bandwidth consume data');
      } finally {
        setLoadingState(prev => ({ ...prev, 'bandwidth-consumption': false }));
      }
    } else {
      setLoadingState(prev => ({ ...prev, 'bandwidth-consumption': false }));
    }
  };

  const fetchConnectedUserStatsData = async () => {
    setLoadingState(prev => ({ ...prev, 'connected-user-stats': true }));
    getSourceCountry()
      .then((response) => {
        if (response?.data?.header?.code === 200) {
          getDestinationCountry()
            .then((response2) => {
              if (response2?.data?.header?.code === 200 && response2?.data?.body?.length) {
                let data = [
                  ...response?.data?.body?.data,
                  ...response2?.data?.body,
                ];
                setSourceDestinationCountry(data);
              }
            })
            .catch((error) => {
              message.error(error?.response?.data?.header?.message || "Something went wrong");
            });
        }
        setFetchedTabs(prev => ({ ...prev, 'connected-user-stats': true }));
        setLoadingState(prev => ({ ...prev, 'connected-user-stats': false }));
      })
      .catch((error) => {
        message.error(error?.response?.data?.header?.message || "Something went wrong");
        setFetchedTabs(prev => ({ ...prev, 'connected-user-stats': true }));
        setLoadingState(prev => ({ ...prev, 'connected-user-stats': false }));
      });
  }

  const fetchNetworkStatsData = () => {
    getResellerNetworkStats()
      .then((response) => {
        if (response?.data?.header?.code === 200) {
          setNetworkStats(response?.data?.body);
        } else {
          // message.error(response?.data?.header?.message || 'Failed to load network stats');
        }
        setFetchedTabs(prev => ({ ...prev, 'network-stats': true }));
      })
      .catch((error) => {
        message.error(error?.response?.data?.header?.message || "Something went wrong");
        setFetchedTabs(prev => ({ ...prev, 'network-stats': true }));
      });
  }
  useEffect(() => {
    const alreadyFetched = fetchedTabs[activeTab];

    if (activeTab === 'user-connected' && fetchedTabs['user-connected'] !== selectedMonth) {
      fetchUserConnectedData(selectedMonth);
      setFetchedTabs(prev => ({
        ...prev,
        'user-connected': selectedMonth
      }));
    } else if (activeTab === 'account-type-wise' && fetchedTabs['account-type-wise'] !== selectedAccountTypeMonth) {
      fetchAccountTypeData(selectedAccountTypeMonth);
      setFetchedTabs(prev => ({
        ...prev,
        'account-type-wise': selectedAccountTypeMonth
      }));
    } else if (activeTab === 'source-country-usage' && fetchedTabs['source-country-usage'] !== selectedSourceCountryMonth) {
      fetchSourceCountryUsageData(selectedSourceCountryMonth);
      setFetchedTabs(prev => ({
        ...prev,
        'source-country-usage': selectedSourceCountryMonth
      }));
    } else if (activeTab === 'bandwidth-consumption' && fetchedTabs['bandwidth-consumption'] !== selectedBandwidthMonth) {
      fetchBandwidthConsumeData(selectedBandwidthMonth);
      setFetchedTabs(prev => ({
        ...prev,
        'bandwidth-consumption': selectedBandwidthMonth
      }));
    } else if (activeTab === 'connected-protocols' && fetchedTabs['connected-protocols'] !== selectMonthConnectedProtocols) {
      fetchConnectedProtocolsData(selectMonthConnectedProtocols);
      setFetchedTabs(prev => ({
        ...prev,
        'connected-protocols': selectMonthConnectedProtocols
      }));
    } else if (activeTab === 'connected-user-stats' && !fetchedTabs['connected-user-stats']) {
      fetchConnectedUserStatsData();
      setFetchedTabs(prev => ({
        ...prev,
        'connected-user-stats': true
      }));
    } else if (activeTab === 'network-stats' && !fetchedTabs['network-stats']) {
      fetchNetworkStatsData();
      setFetchedTabs(prev => ({
        ...prev,
        'network-stats': true
      }));
    } else if (activeTab === 'dau-monthwise' && fetchedTabs['dau-monthwise'] !== `${dauMonthFrom}|${dauMonthTo}`) {
      fetchDAUMonthwiseData(dauMonthFrom, dauMonthTo);
      setFetchedTabs(prev => ({
        ...prev,
        'dau-monthwise': `${dauMonthFrom}|${dauMonthTo}`
      }));
    } else if (activeTab === 'concurrent-users' && fetchedTabs['concurrent-users'] !== `${concurrentFrom}|${concurrentTo}`) {
      fetchConcurrentUsersData(concurrentFrom, concurrentTo);
      setFetchedTabs(prev => ({
        ...prev,
        'concurrent-users': `${concurrentFrom}|${concurrentTo}`
      }));
    }
    
  }, [
    activeTab,
    selectedMonth,
    selectedAccountTypeMonth,
    selectedSourceCountryMonth,
    selectedBandwidthMonth,
    selectMonthConnectedProtocols,
    dauMonthFrom,
    dauMonthTo,
    concurrentFrom,
    concurrentTo
  ]);


  // --- MAU Filter Logic ---
  // Only show months from January up to and including (current month - 3) in 'From' dropdown
  const currentMonth = moment();
  const lastFromMonth = moment().subtract(2, 'months');
  const fromMonthOptions = [];
  for (let m = 0; m <= lastFromMonth.month(); m++) {
    const monthObj = moment().month(m).year(currentMonth.year());
    fromMonthOptions.push({
      value: monthObj.format('YYYY-MM'),
      label: monthObj.format('MMMM YYYY'),
      disabled: dauMonthTo === monthObj.format('YYYY-MM')
    });
  }

  // Set default for dauMonthFrom to the last available option in fromMonthOptions
  const defaultDauMonthFrom = fromMonthOptions.length > 0 ? fromMonthOptions[fromMonthOptions.length - 1].value : '';

  // 'To' month: only months at least 2 months after 'from', up to and including current month
  const getToMonthOptions = (fromMonth) => {
    if (!fromMonth) return [];
    const from = moment(fromMonth, 'YYYY-MM');
    return Array.from({length: currentMonth.month() + 1})
      .map((_, i) => {
        const m = moment().month(i).year(currentMonth.year());
        return {
          value: m.format('YYYY-MM'),
          label: m.format('MMMM YYYY'),
          disabled: m.diff(from, 'months') < 2 || m.isSameOrBefore(from) || dauMonthFrom === m.format('YYYY-MM')
        };
      })
      .filter(opt => !opt.disabled && !moment(opt.value, 'YYYY-MM').isAfter(currentMonth));
  };

  // --- Remove any error popup or max range check in fetchDAUMonthwiseData ---
  const fetchDAUMonthwiseData = async (fromMonth, toMonth) => {
    if (!fromMonth || !toMonth) return;
    const from = moment(fromMonth, 'YYYY-MM');
    const to = moment(toMonth, 'YYYY-MM');
    // No error popup, no max range check
    const sFromDate = from.startOf('month').format('YYYY-MM-DD');
    const sToDate = to.endOf('month').format('YYYY-MM-DD');
    if (keycloak.token && keycloak.tokenParsed?.reseller_id) {
      setLoad(true);
      try {
        const response = await getConnectedUsersMonthwiseReport(sFromDate, sToDate, keycloak.token);
        if (response?.data?.header?.code === 200 && response?.data?.body?.dateWiseData) {
          const sortedData = response.data.body.dateWiseData.sort((a, b) => a.date.localeCompare(b.date));
          setDauMonthwiseData(sortedData);
        } else {
          setDauMonthwiseData([]);
        }
      } catch (error) {
        setDauMonthwiseData([]);
        message.error('Failed to fetch DAU monthwise data');
      } finally {
        setLoad(false);
      }
    } else {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (fromMonthOptions.length > 0) {
      setDauMonthFrom(fromMonthOptions[fromMonthOptions.length - 1].value);
    }
  }, [fromMonthOptions.length]);

  // useEffect(() => {
  //   fetchDAUMonthwiseData(dauMonthFrom, dauMonthTo);
  // }, [dauMonthFrom, dauMonthTo, keycloak.token]);

  const fetchConcurrentUsersData = async (fromMonth, toMonth) => {
    if (!fromMonth || !toMonth) return;
    // Enforce max 1 year range
    const from = moment(fromMonth, 'YYYY-MM');
    const to = moment(toMonth, 'YYYY-MM');
    if (to.diff(from, 'years', true) > 1) {
      message.error('You can select a maximum range of 1 year.');
      return;
    }
    const sFromDate = from.startOf('month').format('YYYY-MM-DD');
    const sToDate = to.endOf('month').format('YYYY-MM-DD');
    if (keycloak.token && keycloak.tokenParsed?.reseller_id) {
      setLoad(true);
      try {
        const response = await getConcurrentUsersReport(sFromDate, sToDate, keycloak.token);
        if (response?.data?.header?.code === 200 && response?.data?.body?.dateWiseData) {
          const sortedData = response.data.body.dateWiseData.sort((a, b) => a.date.localeCompare(b.date));
          setConcurrentData(sortedData);
        } else {
          setConcurrentData([]);
        }
      } catch (error) {
        setConcurrentData([]);
        message.error('Failed to fetch concurrent users data');
      } finally {
        setLoad(false);
      }
    } else {
      setLoad(false);
    }
  };

  // useEffect(() => {
  //   fetchConcurrentUsersData(concurrentFrom, concurrentTo);
  // }, [concurrentFrom, concurrentTo, keycloak.token]);

  const initialTabs = [
    {
      key: "source-country-usage",
      label: "Source Country",
      children: (
        <div>
          <div style={{
            marginBottom: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{ margin: 0 }}>
              <h2 style={{ margin: 0 }}>Source Country</h2>
              <small style={{ color: '#666' }}>(Engagement by Country of Origin)</small>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>{/* Container for dropdowns */}
              <Select
                style={{ width: 180 }}
                value={showAllSourceCountries ? 'all' : 'top5'}
                onChange={value => setShowAllSourceCountries(value === 'all')}
                options={[
                  { value: 'top5', label: 'Top 5 Countries' },
                  { value: 'all', label: 'All Countries' }
                ]}
              />
              <Select
                style={{ width: 200 }}
                value={selectedSourceCountryMonth}
                onChange={setSelectedSourceCountryMonth}
                options={monthOptions}
              />
            </div>
          </div>
          <Spin spinning={loadingState['source-country-usage']} indicator={antIcon}>
            <SourceCountryUsageChart data={sourceCountryUsageData} showAllCountries={showAllSourceCountries} />
          </Spin>
        </div>
      ),
    },
    {
      key: "user-connected",
      label: "Connected Users",
      children: (
        <div>
          <div style={{
            marginBottom: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{ margin: 0 }}>
              <h2 style={{ margin: 0 }}>Connected User Count</h2>
              <small style={{ color: '#666' }}>(Daily Active Users)</small>
            </div>
            <Select
              style={{ width: 200 }}
              value={selectedMonth}
              onChange={setSelectedMonth}
              options={monthOptions}
            />
          </div>
          <Spin spinning={loadingState['user-connected']} indicator={antIcon}>
            <UserConnectedChart data={userConnectedData} />
          </Spin>
        </div>
      ),
    },
    {
      key: "account-type-wise",
      label: "Account Type",
      children: (
        <div>
          <div style={{
            marginBottom: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{ margin: 0 }}>
              <h2 style={{ margin: 0 }}>Account Type Wise</h2>
              <small style={{ color: '#666' }}>(Free/Paid/Trial)</small>
            </div>
            <Select
              style={{ width: 200 }}
              value={selectedAccountTypeMonth}
              onChange={setSelectedAccountTypeMonth}
              options={monthOptions}
            />
          </div>
          <Spin spinning={loadingState['account-type-wise']} indicator={antIcon}>
            <AccountTypeChart data={accountTypeData} />
          </Spin>
        </div>
      ),
    },
    {
      key: "connected-protocols",
      label: "Connected Protocols",
      children: (() => {
        return (
          <div>
            <div
              style={{
                marginBottom: 16,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ margin: 0 }}>
                <h2 style={{ margin: 0 }}>Connected Protocols</h2>
                <small style={{ color: '#666' }}>Protocol wise Connected Users count</small>

              </div>
              <Select
                style={{ width: 200 }}
                value={selectMonthConnectedProtocols}
                onChange={setSelectedMonthConnectedProtocols}
                options={monthOptions}
              />
            </div>
            <Spin spinning={loadingState['connected-protocols']} indicator={antIcon}>
              <ConnectedProtocolsChart data={connectedProtocolsData} />
            </Spin>
          </div>
        );
      })(),
    },
    {
      key: "bandwidth-consumption",
      label: "Overall Bandwidth",
      children: (
        <div>
          <div style={{
            marginBottom: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <h2 style={{ margin: 0 }}>Bandwidth Consumption</h2>
            <Select
              style={{ width: 200 }}
              value={selectedBandwidthMonth}
              onChange={setSelectedBandwidthMonth}
              options={monthOptions}
            />
          </div>
          <Spin spinning={loadingState['bandwidth-consumption']} indicator={antIcon}>
            <BandwidthConsumeChart data={bandwidthConsumeData} />
          </Spin>
        </div>
      ),
    },
    {
      key: "connected-user-stats",
      label: "Connected User Statistics",
      children: (
        <div>
          <div style={{
            marginBottom: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <h2 style={{ margin: 0 }}>Connected User Statistics</h2>
            <small style={{ color: '#666' }}>(By Country - Source vs Destination)</small>
          </div>
          <Card className="side-panel align-center">
            <Spin spinning={loadingState['connected-user-stats']} indicator={antIcon}>
              <ConnectedUserStatsChart data={sourceDestinationCountry} />
            </Spin>
          </Card>
        </div>
      ),
    },
    {
      key: "network-stats",
      label: "Network Statistics",
      children: (
        <div>
          <div style={{
            marginBottom: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <h2 style={{ margin: 0 }}>Network Statistics</h2>
            <small style={{ color: '#666' }}>External Mixpanel Dashboard</small>
          </div>
          <Card className="side-panel">
            <Spin spinning={loadingState['network-stats']} indicator={antIcon}>
              <NetworkStatsChart url={networkStats?.mixpanel_url} />
            </Spin>
          </Card>
        </div>
      ),
    },
    {
      key: "dau-monthwise",
      label: "MAU",
      children: (
        <div>
          <div style={{
            marginBottom: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{ margin: 0 }}>
              <h2 style={{ margin: 0 }}>MAU</h2>
              <small style={{ color: '#666' }}>(Monthly Active Users)</small>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <Select
                style={{ width: 140 }}
                value={dauMonthFrom}
                onChange={setDauMonthFrom}
                options={fromMonthOptions}
                placeholder="From Month"
              />
              <Select
                style={{ width: 140 }}
                value={dauMonthTo}
                onChange={setDauMonthTo}
                options={getToMonthOptions(dauMonthFrom)}
                placeholder="To Month"
                disabled={!getToMonthOptions(dauMonthFrom).length}
              />
            </div>
          </div>
          <DAUMonthwiseChart data={dauMonthwiseData} />
        </div>
      ),
    },
    {
      key: "concurrent-users",
      label: "User Concurrent Load",
      children: (
        <div>
          <div style={{
            marginBottom: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{ margin: 0 }}>
              <h2 style={{ margin: 0 }}>User Concurrent Load</h2>
              <small style={{ color: '#666' }}>(Subscription <span style={{ color: '#1976d2' }}>● paid</span>)</small>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <Select
                style={{ width: 140 }}
                value={concurrentFrom}
                onChange={setConcurrentFrom}
                options={monthOptions}
                placeholder="From Month"
              />
              <Select
                style={{ width: 140 }}
                value={concurrentTo}
                onChange={setConcurrentTo}
                options={monthOptions}
                placeholder="To Month"
              />
            </div>
          </div>
          <ConcurrentUsersChart data={concurrentData} />
        </div>
      ),
    },
  ];

  const itemsForTabs = initialTabs;
  const tabStyles = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5px',
    marginBottom: '20px',
  };
  const tabItemStyles = isActive => ({
    borderRadius: '12px',
    padding: '4px 13px',
    fontWeight: 600,
    fontSize: '14px',
    border: isActive ? 'none' : '1px solid #e5e7eb',
    background: isActive ? '#7c3aed' : '#f8fafc',
    color: isActive ? '#fff' : '#6b7280',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.2s',
  });

  useEffect(() => {
    if (activeTab && !itemsForTabs.some(tab => tab.key === activeTab)) {
      setActiveTab(itemsForTabs[0]?.key || null);
    }
  }, [itemsForTabs, activeTab]);

  return (
    <Card className="design-card">
      <Row gutter={[24, 30]}>
        {/* <Col span={24}>
          <Breadcrumb>
            <Breadcrumb.Item>Disrupt</Breadcrumb.Item>
            <Breadcrumb.Item>Reports</Breadcrumb.Item>
          </Breadcrumb>
        </Col> */}
        <Col span={12}>
          <Headings
            title="Statistical Reports"
            titleSize={2}
            description={`Visualize Statistical Reports`}
            space={5}
            descClass="mb-0 c-gray"
          />
        </Col>
        <Col span={24}>
          <Spin indicator={antIcon} size="large" spinning={load}>
            <div style={tabStyles}>
              {itemsForTabs.map(tab => (
                <button
                  key={tab.key}
                  style={tabItemStyles(activeTab === tab.key)}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <div style={{ minHeight: '500px' }}>
              {itemsForTabs.find(tab => tab.key === activeTab)?.children}
            </div>
          </Spin>
        </Col>
      </Row>
    </Card>
  );
};
export default Reports;